import $ from 'jquery';
import AuthHeader from '../../helpers/AuthHeader';
import BuildQS from '../../helpers/BuildQS';
import config from '../../config/config';

export const transactionTypesService = {
    getTransactionTypeStats,
    getTransactionTypes,
    getTransactionTypeStatuses,
    changeTransactionTypeStatus
};

function getTransactionTypeStats(globalFilter){
    return config.live ? getTransactionTypeStatsLive(globalFilter) : getTransactionTypeStatsStatic();
}


function getTransactionTypeStatsLive(globalFilter) {
    
    let baseUrl = config.apis.v3_data,
        qs = BuildQS(globalFilter),
        requestOptions = {
            headers: AuthHeader()
        };
        
    baseUrl += '/data_admin?' + $.param(qs);
    
    return fetch(baseUrl, requestOptions)
    .then(res=>{   
        return res.json()
    })
}

function getTransactionTypeStatsStatic() {
    let baseUrl = `${config.apis.sales}/api/static/data_admin.json`;
    return fetch(baseUrl, {
        method: 'GET'
    })
    .then(res=>{   
        return res.json()
    })
}

function getTransactionTypeStatuses() {
    const baseUrl = `${config.apis.orthus}/v1/data_admin_records`,
        requestOptions = {
            method: 'GET',
            headers: AuthHeader()
        };        
    
    return fetch(baseUrl, requestOptions)
    .then(res=>{   
        return res.json()
    })
}

function changeTransactionTypeStatus(params) {
    const baseUrl = `${config.apis.orthus}/v1/data_admin_records`,
        requestOptions = {
            method: 'POST',
            headers: AuthHeader({'Content-Type': 'application/json'}),            
            body: JSON.stringify(params)
        };        
    
    return fetch(baseUrl, requestOptions)
    .then(res=>{   
        return res.json()
    })
}

function getTransactionTypes(){
    return config.live ? getTransactionTypesLive() : getTransactionTypesStatic();
}

function getTransactionTypesLive(params) {
    const baseUrl = `${config.apis.secStat}/transaction_types_collection`,
        requestOptions = {
            headers: AuthHeader({'Content-Type': 'application/json'}),            
            body: JSON.stringify(params)
        };        
    
    return fetch(baseUrl, requestOptions)
    .then(res=>{   
        return res.json()
    })
}

function getTransactionTypesStatic() {
    let baseUrl = `${config.apis.sales}/api/static/sec/transaction_types_collection.json`;
    return fetch(baseUrl, {
        method: 'GET'
    })
    .then(res=>{   
        return res.json()
    })
}